import { LocalitiesAutocompleteDTO } from './LocalitiesAutocompleteDTO';

export type LocalityValue = Readonly<{
    value: string;
    label: string;
}>;

export const mapLocalities = (localitiesDTO: LocalitiesAutocompleteDTO): LocalityValue[] => {
    return localitiesDTO.localities.map((localityDTO) => ({
        value: localityDTO.public_id,
        label: localityDTO.description,
    }));
};
